import type { UserPreferences } from '@/core/models/preferences';
import { DEFAULT_PREFS } from '@/core/stores/prefsStore';

export const APPEARANCE_KEYS = {
  theme: ['themeMode', 'accent', 'accentCustom', 'finish'],
  cards: [
    'overlayGradient',
    'overlayGradientStrength',
    'postGradientStrength',
    'panelGradientStrength',
    'cardColor',
    'cardColorStrength',
  ],
  material: ['cardSheen', 'cardGrain', 'cardEdge', 'cardElevation'],
  glass: [
    'radiusPx',
    'radiusMinPx',
    'radiusMaxPx',
    'cardsOverlay',
    'panelSolidity',
    'glassBlur',
    'glassTint',
    'glassSaturation',
  ],
  text: ['textSize'],
  motion: ['backdrop', 'bgIntensity', 'reduceMotion', 'bannerAnimations'],
} as const satisfies Record<string, readonly (keyof UserPreferences)[]>;

export type AppearanceCategory = keyof typeof APPEARANCE_KEYS;
export const ALL_APPEARANCE_KEYS = Object.values(APPEARANCE_KEYS).flat();

export function appearanceValues(
  keys: readonly (keyof UserPreferences)[],
  prefs = DEFAULT_PREFS,
): Partial<UserPreferences> {
  return Object.fromEntries(keys.map((key) => [key, prefs[key]]));
}
